export default __webpack_public_path__ + "static/media/profile-contacts.4aed5997.svg";